export const DATASET_LOCK_CODE = 'DATASET_LOCK' as const;

export class DatasetLockError extends Error {
  readonly code = DATASET_LOCK_CODE;

  readonly status = 409;

  readonly needsRefetch = true;

  constructor(message = 'Dataset is locked. Refetch and try again.') {
    super(message);
    this.name = 'DatasetLockError';
  }
}

export function isDatasetLockError(error: unknown): error is DatasetLockError {
  return error instanceof DatasetLockError;
}
